import { createContext } from 'react';
import type { ActiveWorkflowCompletion } from './viewPage.workflows.query';

export type ActionContextInterface = {
  activeWorkflows: ActiveWorkflowCompletion[];
  /** True while the page's active-workflows query is in flight (empty list is not trustworthy). */
  activeWorkflowsLoading?: boolean;
  activeUserId?: string;
  unsignedDocuments: boolean;
  refetch: () => void;
  refreshWidgets?: () => void;
  widgetRefreshSignal?: number;
};

export const ActionContext = createContext<ActionContextInterface>({
  activeWorkflows: [],
  activeWorkflowsLoading: false,
  unsignedDocuments: false,
  refetch: () => {},
  refreshWidgets: () => {},
  widgetRefreshSignal: 0,
});
